import type { PropsWithChildren } from "react";
import { LoadingHome } from "@/components/loading-home";
import { useAuth0 } from "@auth0/auth0-react";
import { Redirect, useLocation } from "react-router-dom";

export function CoreLayout({ children }: PropsWithChildren) {
  const { isLoading, isAuthenticated } = useAuth0();
  const { pathname } = useLocation();

  if (isLoading) {
    return <LoadingHome />;
  }

  if (isAuthenticated && pathname === "/login") {
    return <Redirect to="/" />;
  }

  if (
    !isAuthenticated &&
    pathname !== "/login" &&
    pathname !== "/signup" &&
    pathname !== "/user-not-found"
  ) {
    return <Redirect to="/login" />;
  }

  return <>{children}</>;
}
